import { useState } from "react";
import Input from "../../../design/Input";
import LandSelect from "../../../design/LandSelect";
import TableDatalis from "./TableDatalis";
import regx from "../../../../functions/regx";


export default function Passport ({data, setData}) {
    const templatePassport = {land: "ישראלי", number: "", firstName: data.firstName, lastName: data.lastName, issue: "", expiry: "", num: 0};
    const head = ["מס'", "אזרחות", "מס' דרכון", "שם", "תאריך תפוגה", "", ""];
    const [dataPassport, setDataPassport] = useState(templatePassport);

    function expiryTenYears(e) {
        let date = new Date(e);

        if (! isNaN(date.getTime())) {
            date.setFullYear(date.getFullYear() + 10);
            date.setDate(date.getDate() - 1);
            setDataPassport({...dataPassport, issue: e, expiry: date.toISOString().slice(0,10)});
        }
    }

    function insertPassportToSlice () {
        if (regx('passpord', dataPassport.number, false) && regx('strEn', dataPassport.lastName) && 
        regx('strEn', dataPassport.firstName) && regx('date', dataPassport.issue) && regx('date', dataPassport.expiry)) {
            let num;
            if (dataPassport.num === 0) {
                let keys = Object.keys(data.passport);
                num = (keys.length ? Math.max(...keys) : 0) + 5
            } else {
                num = dataPassport.num;
            }
            let passport = {...data.passport, [num]: dataPassport};
            setData({...data, passport: passport});
            setDataPassport(templatePassport);
        }
    }

    return (
        <div>
            <div className="passpord">
                <p> אזרחות </p>
                <LandSelect 
                onChange={(e) => setDataPassport({...dataPassport, land: e.target.value})} 
                value={dataPassport.land} 
                />                
                <p> מס' דרכון </p>
                <Input 
                type="text" 
                myStyle='input2' 
                value={dataPassport.number} 
                onChange={(e) => setDataPassport({...dataPassport, number: e})} 
                pattern="passpord" 
                language={'en'} 
                />
                <p> שם פרטי </p>
                <Input 
                type="text" 
                myStyle="input2" 
                value={dataPassport.firstName} 
                onChange={(e) => setDataPassport({...dataPassport, firstName: e})} 
                pattern="strEn" 
                language={'en'} 
                />
                <p> שם משפחה </p>
                <Input 
                type="text" 
                myStyle="input2" 
                value={dataPassport.lastName} 
                onChange={(e) => setDataPassport({...dataPassport, lastName: e})} 
                pattern='strEn' 
                language={'en'} 
                />
                <p>תאריך הוצאה</p>
                <Input 
                type="date" 
                myStyle='input2' 
                value={dataPassport.issue} 
                onChange={(e) => {expiryTenYears(e)}} 
                pattern={'date'} 
                />
                <p>תאריך פקיעה</p>
                <Input 
                type="date" 
                myStyle='input2' 
                value={dataPassport.expiry} 
                onChange={(e) => setDataPassport({...dataPassport, expiry: e})} 
                pattern={'date'} 
                /> 
            </div>

            <p onClick={insertPassportToSlice} className="addPasspord"> הוסף \ עדכן</p>

            <TableDatalis
            head={head}
            data={data.passport}
            name={'passport'} 
            edit={(value) => setDataPassport({...data.passport[value], num: value}) } 
            myDelete={(value) => {
                let passport = data.passport;
                delete passport[value];
                setData({...data, passport: {...passport}});
            }}
            />
        </div>
    )
}